export default __webpack_public_path__ + "static/media/Cindy Hyde-Smith.2954d399.jpg";